import { CountryDemo } from "component/w24/structure/CountryDemo"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const Countries = (props: Props): JSX.Element => {
  return (
    <S_Countries className={props.className}>
      <CountryDemo country="Norway" />
      <CountryDemo country="Denmark" />
      <CountryDemo country="Czechia" />
      <CountryDemo country="Slovakia" />
      <CountryDemo country="Faroe Islands" />
    </S_Countries>
  )
}

const S_Countries = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  @media only screen and (min-width: 1260px) {
    gap: 60px;
  }
`
